/* eslint-disable  */
//@ts-nocheck
import { ReactNode, useEffect, useMemo, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { InputLabel } from './InputLabel';
import { useGetter, useMouseDownOutside } from './utils';
import * as styles from './Select.css';

export const Select = <V extends unknown>({
  value,
  valueList,
  onChange,
  label,
}: {
  value: V;
  valueList: { value: V; label?: ReactNode; labelWhenSelected?: ReactNode }[];
  label?: string;
  onChange: (val: V) => any;
}) => {
  const [open, setOpen] = useState(false);

  const getOpen = useGetter(open);

  const dropdownRef = useRef<HTMLDivElement>(null!);

  const foundValue = useMemo(
    () =>
      valueList.find((x) => JSON.stringify(x.value) === JSON.stringify(value)),
    [value],
  );

  useMouseDownOutside(dropdownRef, () => {
    if (getOpen()) setOpen(false);
  });

  return (
    <div className="cursor-pointer">
      <InputLabel {...{ label }} />

      <div className="relative" ref={dropdownRef}>
        <div
          className="font-semibold px-4 py-2 rounded-lg flex items-center justify-between border-2 border-[#DAE1ED] bg-[#FAFCFD]"
          onClick={() => setOpen((x) => !x)}
        >
          {
            (foundValue?.labelWhenSelected ??
              foundValue?.label ??
              foundValue?.value) as ReactNode
          }

          <FontAwesomeIcon
            icon={faChevronDown}
            className="text-[#101426] text-md ml-3 margin-right[-7px] leading-none"
          />
        </div>
        {open ? (
          <div className="absolute top-full w-full mt-2 z-[1] rounded-lg border-2 border-[#DAE1ED] bg-[#FAFCFD]">
            {valueList.map((el, i) => (
              <div
                className={styles.valueListItem}
                key={i}
                onClick={() => {
                  onChange(el.value);
                  setOpen(false);
                }}
              >
                <div>{el.label ?? (el.value as ReactNode)}</div>
                {foundValue?.value === el.value ? (
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="text-[#101426] text-md ml-3 margin-right[-7px] leading-none"
                  />
                ) : null}
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};
